import { getAllTests, runTests } from "@benchristel/taste"
import { useEffect, useState } from "preact/hooks"

export function TestResults() {
  const [results, setResults] = useState<any>({ results: [] })

  useEffect(() => {
    runTests(getAllTests()).then((results: any) => {
      setResults(results)
      console.debug(results)
    })
  }, [])

  return results.results.some((r: any) => r.error) ? (
    <div style="padding:12px;background:#fee">
      There are test failures. <a href="localhost:8080/test.html">See them.</a>
    </div>
  ) : null
}
